import Preact, {h, Component} from 'preact';
import {connect} from 'preact-redux';
import DateTime from '/chat/src/common/js/lib/DateTime';
import DefaultProfileImage from '/chat/src/components/DefaultProfileImage';
import style from './style.scss'
import TextDisplay from '/chat/src/components/TextDisplay';

class Message extends Component{
    render() {
        const index = this.props.entryIndex;
        if (this.shouldDisplaySupportInfo())
            return this.renderMessageWithSupportInfo();
        return this.renderMessage();
    }

    hasPreviousMessage(){
        const current = this.props.entry
        const previous = this.props.previousEntry

        if(this.props.index == 0) return false;
        if(!previous) return false
        if(!previous.size) return false
        if(previous.get('meta')) return false
        if(this.shouldRenderTime(previous)) return false
        if(current.get('creator_id') !== previous.get('creator_id')) return false

        return true;
    }
    hasNextMessage(){
        const current = this.props.entry
        const next = this.props.nextEntry
        if(!next) return false
        if(!next.size) return false
        if(next.get('meta')) return false
        if(this.shouldRenderTime(next)) return false
        if(current.get('creator_id') !== next.get('creator_id')) return false

        return true
    }
    shouldDisplaySupportInfo() {
        const index = this.props.entryIndex;
        if(this.isSupportEntryCreator()){
            if(!this.hasPreviousMessage(index)){
                return true;
            }
        }
        return false
    }


    renderMessage() {
        const entry = this.props.entry;
        const entryBody = entry.get('entry_body') || '';

        const direction = this.getMessageDirection();
        const customStyle = {};

        if (direction === 'customer')
            customStyle.backgroundColor = this.props.color;
        return (
            <div className={style.MessageWrapper}>
                {this.renderTime()}
                <div
                    class={`message message--${direction} message--single`}
                >
                    <div class='message__body' style={customStyle}>
                        <TextDisplay text={entryBody}/>
                    </div>
                </div>
            </div>
        );
    }

    renderMessageWithSupportInfo() {
        return (
            <div>
                {this.renderSupportInfo()}
                {this.renderMessage()}
            </div>
        );
    }

    renderSupportInfo() {
        const entry = this.props.entry;

        if (this.doesConversationExist()) {
            const supportParticipant = this.getSupportParticipant(entry.get('creator_id'))
            if (supportParticipant) {
                let name = supportParticipant.get('display_name');
                if(!name)
                name = supportParticipant.get('name');
                const profileImageUrl = supportParticipant.get('image_url');
                let imageElement = null;

                if (profileImageUrl) {
                    imageElement = <img src={profileImageUrl} class='message-support-info__profile-image' />;
                } else {
                    imageElement =( <div className='message-support-info__profile-image'>
                        <DefaultProfileImage color={this.props.color}/>
                    </div>)
                }
                return (
                    <div class='message-support-info'>
                        {imageElement}
                        <span class='message-support-info__name'>{name}</span>
                    </div>
                );
            }
            else {
                return null;
            }
        } else {
            return null;
        }
    }

    getSupportParticipant(id) {
        return this.props.employees.get(id.toString())
    }

    renderTime() {
        const index = this.props.entryIndex;
        if(index !== 0) return null;
        const dateString = this.props.conversationEntries.getIn([this.props.entryIndex, 'date_created']);
        if(!dateString)
            return null;
        const dateTime = DateTime.getDetailedNiceDate(dateString);
        return (
            <div class={style.TimeMessage}>
                <div class={style.TimeBody}> {dateTime} </div>
            </div>
        );
    }
    shouldRenderTime(diffEntry){
        const currentDate = this.props.entry.get('date_created');
        const diffDate = diffEntry.get('date_created')
        if (DateTime.getDiffMinutes(currentDate, diffDate) > 30)
            return true;
        return false;
    }

    getMessageDirection() {
        if (this.isVisitorEntryCreator())
            return 'customer';
        return 'support';
    }

    doesConversationExist() {
        return this.props.conversation !== null;
    }

    isSupportEntryCreator() {
        return !this.isVisitorEntryCreator();
    }

    isVisitorEntryCreator() {
        const visitorId = this.props.visitor.get('id');
        const entry = this.props.entry;
        return visitorId === entry.get('creator_id');
    }

    isFirstMessage() {
        const entryIndex = this.props.entryIndex;
        return entryIndex === 0;
    }

    getLastMessageIndex() {
        const conversationEntries = this.props.conversationEntries;
        return conversationEntries.size-1;
    }
}


export default Message;



// WEBPACK FOOTER //
// ./routes/Chat/Chat/Message.js